import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    CHANGE_LANGUAGE: createAction('GLOBAL/LANG/CHANGE_LANGUAGE'),
    FETCH_ERROR: createAction('GLOBAL/LANG/FETCH_ERROR_LANGUAGE'),
    FETCH_REQUEST: createAction('GLOBAL/LANG/FETCH_REQUEST_LANGUAGE'),
    FETCH_SUCCESS: createAction('GLOBAL/LANG/FETCH_SUCCESS_LANGUAGE'),
    UPDATE_ERROR: createAction('GLOBAL/LANG/UPDATE_ERROR_LANGUAGE'),
    UPDATE_REQUEST: createAction('GLOBAL/LANG/UPDATE_REQUEST_LANGUAGE'),
    UPDATE_SUCCESS: createAction('GLOBAL/LANG/UPDATE_SUCCESS_LANGUAGE'),
    FETCH_TRANSLATED_LANG_REQUEST: createAction('GLOBAL/LANG/FETCH_TRANSLATED_LANG_REQUEST'),
    FETCH_TRANSLATED_LANG_SUCCESS: createAction('GLOBAL/LANG/FETCH_TRANSLATED_LANG_SUCCESS'),
    FETCH_TRANSLATED_LANG_ERROR: createAction('GLOBAL/LANG/FETCH_TRANSLATED_LANG_ERROR'),
};
export const initialState = Map({
    fetchError: null,
    lang: null,
    languages: null,
    updateError: null,
    updateProcessing: null,
    translatedLanguages: null,
});
const reducer = handleActions({
    [actions.CHANGE_LANGUAGE.toString()]: (state, action) => state.set('lang', action.payload),
    [actions.UPDATE_REQUEST.toString()]: (state) => state.merge({
        error: false,
        updateProcessing: true,
    }),
    [actions.UPDATE_SUCCESS.toString()]: (state, action) => state.merge({
        lang: action.payload,
        updateProcessing: false,
    }),
    [actions.UPDATE_ERROR.toString()]: (state, action) => state.merge({
        error: action.payload,
        updateProcessing: false,
    }),
    [actions.FETCH_SUCCESS.toString()]: (state, action) => state.set('languages', action.payload),
    [actions.FETCH_ERROR.toString()]: (state, action) => state.set('fetchError', action.payload),
    [actions.FETCH_TRANSLATED_LANG_SUCCESS.toString()]: (state, action) => state.set('translatedLanguages', action.payload),
}, initialState);
export default reducer;
